import React from "react";
import { useState, useEffect } from "react";
import DropDownComp from "../image/DropDownComp";
import TrunAroundList from "../TrunAroundList";
import { useSelector, useDispatch } from "react-redux";
import { fetchCandidateDetails } from "../../../redux/actions/CompanyDashboardAction";
import { candidateDetails } from "../image/datas";
import MainLoader from "../../Loader/MainLoader";
import Empty from "../../Empty/Empty";

function CandidateDetailsList({
  dateDropDown,
  setDropDown,
  startDate,
  endDate,
  setItemsPerPage,
  itemsPerPage,
  setBgvCountStartDate,
  setSelections,
  setStartDate,
  setEndDate,
  settatOverviewStartDate,
  settatOverviewEndDate,
  setStatusCountStartDate,
  setStatusCountEndDate,
  setStatusCountKey,
  setBgvCountEndDate,
}) {
  // const [dateDropDown, setDropDown] = useState({TAT: false, AmountSpent: false, status: false, packDetails: false, ACC: false, candidateDetails:false});
  const [toggleBtn, setToggleBtn] = useState("invitation");
  const [requestPage, setRequestPage] = useState(1);
  const [candidateFetch, setCandidateFetch] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCandidate, setTotalCandidate] = useState(0);
  const currentYear = new Date().getFullYear();
  const clientInfoID = localStorage.getItem("client_info_id");
  const masterID = localStorage.getItem("master_id");
  const dispatch = useDispatch();
  const dropDownData = [
    "All",
    "Current Week",
    "Previous Week",
    "Current Month",
    "Previous Month",
    "Current Year",
    "Previous Year",
  ];
  const lastTenYears = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const fetchCandidateDetailsLoading = useSelector(
    (state) => state.fetchCandidateDetails.loading
  );

  const [selectValue, setSelectedValue] = useState({
    TAT: "All",
    status: "All",
    packDetails: "All",
    candidateDetails: "All",
    AmountSpent: lastTenYears[0],
  });

  useEffect(() => {
    fetchCandidateDashboard();
  }, [startDate, endDate, itemsPerPage, requestPage, toggleBtn]);

  const fetchCandidateDashboard = () => {
    let key = "all";
    if (startDate && endDate !== "") {
      key = "";
    }

    const offset = (requestPage - 1) * itemsPerPage;

    const data = {
      client_info_id: clientInfoID,
      master_id: masterID,
      start_date: startDate,
      end_date: endDate,
      candidate_details_type: toggleBtn,
      offset: offset,
      limits: itemsPerPage,
    };

    const successFn = (response) => {
      console.log("Recent search data fetched successfully", response.data);
      setCandidateFetch(response.data?.candidate_details);
      setTotalCandidate(response?.data?.overall_count);
    };

    const failureFn = (error) => {
      console.error("Data fetching failed", error);
      alert(error);
    };

    dispatch(fetchCandidateDetails({ data, successFn, failureFn }));
  };

  const pagination = () => {
    const totalPages = Math.ceil(totalCandidate / itemsPerPage);
    return (
      <>
        {Array.from({ length: totalPages }).map((_, index) => (
          <button
            key={index}
            className={`pageButton ${
              requestPage === index + 1 ? "active" : ""
            }`}
            onClick={() => setRequestPage(index + 1)}>
            {index + 1}
          </button>
        ))}
      </>
    );
  };

  console.log("candidateFetch", candidateFetch)

  const invitationData = () => {
    const startIndex = (currentPage - 1) * toggleBtn;
    const endIndex = startIndex + parseInt(toggleBtn, 10);
    const paginatedData = candidateDetails.slice(startIndex, endIndex);
    console.log("candidateFetch", candidateFetch);
    return (
      <>
        {candidateFetch.map((value, index) => (
          <div
            key={index}
            className='candidateDetail'>
            <div className='DetailCont'>
              <div>
                <p>Job Seeker Name</p>
                <p title={value?.full_name}>{value?.full_name}</p>
              </div>
              <div>
                <p>Job Seeker ID</p>
                <p>{value.job_seeker_id}</p>
              </div>
              <div>
                <p>Initiated Date</p>
                <p>{value.initiated_time}</p>
              </div>
            </div>
            <button>{value.candidate_status}</button>
          </div>
        ))}
      </>
    );
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setRequestPage(1); // Reset to first page when items per page changes
  };

  const totalPages = Math.ceil(totalCandidate / itemsPerPage);

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const calculateDateRange = (input) => {
    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (input) {
      case "Previous Week":
        const lastSunday = new Date(today);
        lastSunday.setDate(today.getDate() - (today.getDay() + 6));
        start = new Date(lastSunday);
        end = addDaysToDate(lastSunday, 6);
        break;
      case "Current Week":
        start.setDate(today.getDate() - (today.getDay() - 1));
        end.setDate(today.getDate() + (7 - today.getDay()));
        break;
      case "Previous Month":
        start.setMonth(today.getMonth() - 1, 1);
        end.setDate(0);
        break;
      case "Current Month":
        start.setMonth(today.getMonth(), 1);
        end.setMonth(today.getMonth() + 1, 0);
        break;
      case "Previous Year":
        start.setFullYear(today.getFullYear() - 1, 0, 1);
        end.setFullYear(today.getFullYear() - 1, 11, 31);
        break;
      case "Current Year":
        start.setFullYear(today.getFullYear(), 0, 1);
        end.setFullYear(today.getFullYear(), 11, 31);
        break;
      default:
        break;
    }
    const dates = {
      start: start.toISOString().split("T")[0],
      end: end.toISOString().split("T")[0],
    };
    // setStartDate(start.toISOString().split('T')[0]);
    // setEndDate(end.toISOString().split('T')[0]);
    // setSelection(input);
    return dates;
  };

  const addDaysToDate = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const handleSelectChange = (chartName, selectType) => {
    const selectedOption = chartName;

    setSelections((prevSelections) => ({
      ...prevSelections,
      [selectType]: selectedOption,
    }));

    if (selectType === "candidate_details") {
      if (selectedOption === "All") {
        setStartDate("");
        setEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        setStartDate(dates.start);
        setEndDate(dates.end);
      }
    } else if (selectType === "tat_overview") {
      if (selectedOption === "All") {
        settatOverviewStartDate("");
        settatOverviewEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        settatOverviewStartDate(dates.start);
        settatOverviewEndDate(dates.end);
      }
    } else if (selectType === "status_count") {
      if (selectedOption === "All") {
        setStatusCountStartDate("");
        setStatusCountEndDate("");
        setStatusCountKey("all");
      } else {
        const dates = calculateDateRange(selectedOption);
        setStatusCountStartDate(dates.start);
        setStatusCountEndDate(dates.end);
        setStatusCountKey("");
      }
    } else if (selectType === "pack_details") {
      if (selectedOption === "All") {
        setBgvCountStartDate("");
        setBgvCountEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        setBgvCountStartDate(dates.start);
        setBgvCountEndDate(dates.end);
      }
    } else {
    }
  };

  return (
    <div className='userCred'>
      <div className='header'>
        <h1>Candidate Details</h1>
        <div
          onClick={() =>
            setDropDown((prev) => ({
              ...prev,
              candidateDetails: !prev.candidateDetails,
            }))
          }>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 26 26'
            fill='none'>
            <path
              d='M7.53711 16.9837C7.53711 16.5348 7.88633 16.1712 8.31711 16.1712H13.8701C14.3009 16.1712 14.6501 16.5348 14.6501 16.9837C14.6501 17.4324 14.3009 17.7962 13.8701 17.7962H8.31711C7.88633 17.7962 7.53711 17.4324 7.53711 16.9837ZM8.31711 13.0938C7.88633 13.0938 7.53711 13.4574 7.53711 13.9062C7.53711 14.355 7.88633 14.7187 8.31711 14.7187H11.4372C11.8679 14.7187 12.2172 14.355 12.2172 13.9062C12.2172 13.4574 11.8679 13.0938 11.4372 13.0938H8.31711Z'
              fill='var(--AccentColor)'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M9.05133 4.0625C9.48211 4.0625 9.83133 4.42627 9.83133 4.875V5.14956C10.2198 5.14582 10.6338 5.14582 11.0742 5.14583H14.3084C14.7488 5.14582 15.1628 5.14582 15.5513 5.14956V4.875C15.5513 4.42627 15.9005 4.0625 16.3313 4.0625C16.7622 4.0625 17.1113 4.42627 17.1113 4.875V5.203C17.3473 5.22028 17.5696 5.24277 17.7788 5.27206C18.7149 5.40317 19.5031 5.68363 20.1291 6.33571C20.755 6.98779 21.0243 7.80882 21.1501 8.78394C21.2714 9.72316 21.2714 10.9173 21.2713 12.3989V15.7471C21.2713 16.7267 21.2714 17.5167 21.2159 18.1541C21.1588 18.8109 21.0378 19.3848 20.7488 19.9063C20.4065 20.5239 19.9142 21.0367 19.3213 21.3932C18.8208 21.6942 18.2698 21.8202 17.6392 21.8798C17.0274 21.9375 16.269 21.9375 15.3285 21.9375H11.0743C9.65197 21.9375 8.50555 21.9375 7.60391 21.8113C6.66779 21.6802 5.8796 21.3997 5.25361 20.7477C4.62762 20.0955 4.35837 19.2746 4.23251 18.2995C4.11129 17.3602 4.11131 16.166 4.11133 14.6845V12.3989C4.11131 10.9173 4.11129 9.72314 4.23251 8.78394C4.35837 7.80882 4.62762 6.98779 5.25361 6.33571C5.8796 5.68363 6.66779 5.40317 7.60391 5.27206C7.81307 5.24277 8.03542 5.22028 8.27133 5.203V4.875C8.27133 4.42627 8.62054 4.0625 9.05133 4.0625ZM15.5513 6.77485V7.04167C15.5513 7.49039 15.9005 7.85417 16.3313 7.85417C16.7622 7.85417 17.1113 7.49039 17.1113 7.04167V6.83229C17.2739 6.84584 17.4267 6.86239 17.5709 6.88258C18.334 6.98945 18.7382 7.18494 19.0259 7.48476C19.3138 7.78458 19.5014 8.20553 19.6041 9.00046C19.6234 9.15065 19.6393 9.30979 19.6523 9.47917H5.73032C5.74333 9.30979 5.75922 9.15065 5.77859 9.00046C5.8812 8.20553 6.06886 7.78458 6.3567 7.48476C6.64453 7.18494 7.04864 6.98945 7.81177 6.88258C7.95594 6.86239 8.10873 6.84584 8.27133 6.83229V7.04167C8.27133 7.49039 8.62054 7.85417 9.05133 7.85417C9.48211 7.85417 9.83133 7.49039 9.83133 7.04167V6.77485C10.2227 6.77101 10.6539 6.77083 11.1313 6.77083H14.2513C14.7288 6.77083 15.1599 6.77101 15.5513 6.77485ZM5.67518 11.1042C5.67149 11.5119 5.67133 11.9611 5.67133 12.4583V14.625C5.67133 16.18 5.67298 17.2645 5.77859 18.0829C5.8812 18.8778 6.06886 19.2987 6.3567 19.5986C6.64453 19.8984 7.04864 20.0939 7.81177 20.2008C8.59734 20.3108 9.63849 20.3125 11.1313 20.3125H15.2913C16.2777 20.3125 16.9653 20.3117 17.4984 20.2614C18.0209 20.2121 18.3178 20.1203 18.5413 19.986C18.8971 19.772 19.1924 19.4643 19.3978 19.0938C19.5269 18.8609 19.6149 18.5515 19.6623 18.0074C19.7106 17.4521 19.7113 16.7358 19.7113 15.7083V12.4583C19.7113 11.9611 19.7112 11.5119 19.7074 11.1042H5.67518Z'
              fill='var(--AccentColor)'
            />
          </svg>
          <p>{selectValue.candidateDetails}</p>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='8'
            viewBox='0 0 14 8'
            fill='none'>
            <path
              d='M12.5 1L7 7L1.5 1'
              stroke='var(--AccentColor)'
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          {dateDropDown.candidateDetails ? (
            <DropDownComp
              data={dropDownData}
              setSelectedValue={setSelectedValue}
              closeDropDown={() =>{
                setDropDown((prev) => ({
                  ...prev,
                  candidateDetails: !prev.candidateDetails,
                }))}
              }
              handleSelectChange={handleSelectChange}
              chartName='candidate_details'
            />
          ) : (
            ""
          )}
        </div>
        <div className='swapBtn'>
          <p
            className={`${toggleBtn === "invitation" ? "active" : ""}`}
            onClick={() => setToggleBtn("invitation")}>
            Initiated
          </p>
          <p
            className={`${toggleBtn === "TAT" ? "active" : ""}`}
            onClick={() => setToggleBtn("TAT")}>
            TAT
          </p>
        </div>
      </div>
      <div className='credBody'>
        {fetchCandidateDetailsLoading ? (
          <MainLoader />
        ) : (
          <>
          {candidateFetch.length > 0 ?
            <>
              {toggleBtn === "TAT" ? (
                <TrunAroundList data={candidateFetch} />
              ) : (
                <>{invitationData()}</>
              )}
            </>
            :
            <Empty sign="negative" size={10}/>
          }
          </>
        )}
      </div>
      {candidateFetch.length > 0 &&
        <div className='pagination'>
          <button
            className='pageButton'
            disabled={requestPage <= 1}
            onClick={() => setRequestPage((prev) => prev - 1)}>
            <svg
              width='4'
              height='7'
              viewBox='0 0 4 7'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M3.24219 1.01886L0.759429 3.50162L3.24219 5.98438'
                stroke='var(--TextColor)'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
          {pagination()}
          <button
            className='pageButton'
            disabled={requestPage === totalPages}
            onClick={() => setRequestPage((prevPage) => prevPage + 1)}>
            <svg
              width='4'
              height='7'
              viewBox='0 0 4 7'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0.757812 1.01886L3.24057 3.50162L0.757812 5.98438'
                stroke='var(--TextColor)'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
          <div className='dataPerpage'>
            <p>Show</p>
            <select
              id='options'
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}>
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
            </select>
          </div>
        </div>
      }
    </div>
  );
}

export default CandidateDetailsList;
